/**
 * V2 source path: customer/midas/components/v2/ChatWelcomeV2.tsx
 * V1 source: scratch — V1 used `MidasWelcome.tsx` (rich page-level) which is
 *   out-of-scope for Phase 1 (Sidebar + Machine Fresh Session ship in
 *   Phase 3). Phase 1 keeps a minimal centered placeholder so the
 *   zero-messages branch has something to render. Production-replacing
 *   "Machine Fresh Session" artboard implementation comes later.
 * Strategy: scratch-with-reused-handlers
 * Verified no-MUI: yes
 * Phase: 1
 */
import React from "react";

import MidasLogo from "../MidasLogo";

interface ChatWelcomeV2Props {
  onSuggestionClick?: (text: string) => void;
}

const ChatWelcomeV2: React.FC<ChatWelcomeV2Props> = (_props) => {
  return (
    <div className="m-auto flex max-w-md flex-col items-center gap-4 px-6 py-12 text-center">
      <MidasLogo size="lg" animated="none" />
      <h2
        className="font-sora text-[22px] font-semibold leading-tight text-midas-graphite"
        style={{ fontFamily: "'Sora', sans-serif" }}
      >
        Ask Midas anything about this machine
      </h2>
      <p
        className="font-sora text-[14px] leading-relaxed text-midas-warm-graphite"
        style={{ fontFamily: "'Sora', sans-serif" }}
      >
        Hydraulic schematics, alarm codes, service history — start a question
        and Midas will pull the right citations as it goes.
      </p>
      <span className="font-mono text-[10px] uppercase tracking-[0.12em] text-midas-muted-stone">
        Sora · JetBrains Mono · Direction B Molded
      </span>
    </div>
  );
};

export default ChatWelcomeV2;
